import { Fetch } from 'lib/Fetch';

export function requestExtractCertificatión({
  certification,
  statementDate,
}) {
  return new Fetch()
    .url('/user/certification/create-request')
    .method('post')
    .userToken()
    .data({
      certification,
      statementDate,
    })
    .send();
}
